import { assert_not_null } from '@shared/asserts/utils_asserts';
import * as THREE from 'three';
import { Object3D } from 'three';
import { ConstantsOpenPose } from '../../constants_open_pose';
import { EOpenPoseBodyNode } from '../../enums/e_open_pose_body_node';
import { EOpenPoseBodyPartMask } from '../../enums/e_open_pose_body_part_mask';
import { EThreejsStub } from '../../enums/e_threejs_stub';
import { is_match_bone_prefix } from '../../fbx/utils_open_pose_fbx';
import { OpenPoseLimbs } from '../../open_pose_types/open_pose_limbs';
import { OpenPoseBodyController } from '../open_pose_body_controller';

export function get_ancestors(object_3d: Object3D) {
  const out: Object3D[] = [];

  object_3d.traverseAncestors(ancestor => out.push(ancestor));

  return out;
}

export function get_child_nodes(node: Object3D): Object3D[] {
  const out: Object3D[] = [];
  custom_traverse(node, out);

  return out;
}

function custom_traverse(object_3d: Object3D, child_nodes: Object3D[]) {
  for (const child of object_3d.children) {
    if (is_pickable(child.name)) {
      child_nodes.push(child);
    } else {
      custom_traverse(child, child_nodes);
    }
  }
}

export function get_shoulder_width_from_nodes(open_pose_body: OpenPoseBodyController): number {
  const shoulder_left = open_pose_body.get_node(EOpenPoseBodyNode.SHOULDER_LEFT);
  const shoulder_right = open_pose_body.get_node(EOpenPoseBodyNode.SHOULDER_RIGHT);

  return shoulder_left.object.position.distanceTo(shoulder_right.object.position);
}

export function get_node_sphere_mesh(node_object: Object3D): THREE.Mesh {
  let sphere: THREE.Mesh = EThreejsStub.MESH;

  node_object.traverse(child => {
    if (sphere !== EThreejsStub.MESH) return;
    if (child instanceof THREE.Mesh && child.name === `${node_object.name}${ConstantsOpenPose.JOINT_SPHERE_NAME}`) sphere = child;
  });

  return sphere;
}

export function get_child_bones(node: Object3D): Object3D[] {
  const child_bones: Object3D[] = [];

  for (const child of node.children) {
    if (!is_bone(child.name)) continue;

    child_bones.push(child);
  }

  return child_bones;
}

export function is_bone(name: string) {
  return is_match_bone_prefix(name);
}

export function is_pickable(name: string) {
  if (ConstantsOpenPose.OPEN_POSE_KEYPOINTS_LIST.includes(name)) return true;
  if (ConstantsOpenPose.PICKABLE_PARTS_LIST.includes(name)) return true;
  if (is_bone(name)) return true;

  return false;
}

export function is_mask(name: string) {
  return [EOpenPoseBodyPartMask.FOOT as string, EOpenPoseBodyPartMask.HAND as string].includes(name);
}

export function is_hand_or_foot(name: EOpenPoseBodyNode): boolean {
  return (
    name === EOpenPoseBodyNode.HAND_LEFT ||
    name === EOpenPoseBodyNode.HAND_RIGHT ||
    name === EOpenPoseBodyNode.FOOT_LEFT ||
    name === EOpenPoseBodyNode.FOOT_RIGHT
  );
}

export function find_ancestor_pickable_hand_or_foot(object_3d: Object3D) {
  const ancestor = get_ancestors(object_3d).find(object => is_pickable(object.name) || is_hand_or_foot(object.name as OpenPoseLimbs));

  assert_not_null(ancestor);

  return ancestor;
}

export function find_ancestor_pickable(object_3d: Object3D) {
  const ancestor = get_ancestors(object_3d).find(object => is_pickable(object.name));

  assert_not_null(ancestor);

  return ancestor;
}
